function BackButton(props) {
  const { children, onClick } = props;

  return (
    <button type="button" className="disabled:opacity-25 disabled:pointer-events-none bg-white bg-opacity-10 text-white active:bg-black hover:bg-black font-bold uppercase text-xs lg:text-sm px-8 lg:px-20 py-4 rounded-full shadow hover:shadow-md disabled:shadow-none outline-none focus:outline-none mb-1 ease-linear transition-all duration-150 mr-4 ml-4" onClick={onClick}>{children}</button>
  );
}

export default BackButton;
